//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
import "../PDM/PDM.SheetRevision.js";
import "../no/PDM.js";
let d=[[],[[["nEquipment","equipment"],"GetEquipment",{},0,0],[["nRuns","runs"],"GetRuns",{},0,0],[["nPipes","pipes"],"GetPipes",{},0,0]],[["FlowDirectionArrows","PID.FlowDirectionArrowCollection",0],["AutomaticTables","PID.AutomaticTableCollection",0],["Instrumentations","PID.InstrumentationCollection",0]]];
SPLM.PID.Sheet = class extends SPLM.PDM.SheetRevision{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PID.Sheet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;